import { messageSuccess } from 'aa_common/front-end/antd'
import { tryCallApi } from 'common/helpers'
import { getNs } from 'common/i18n-config'
import { FixedAssetsService } from 'common/open-api'
import { getAxiosSilent } from 'common/open-api/helper'
import { handleErrorResponse } from 'common/utils/response-helper'
import { useState } from 'react'
import { useParams } from 'react-router-dom'

import { parseCancelAcceleratedError } from '../helpers/parse-cancel-accelerated-error'
import { Cancel_Accelerated_Depreciation_Error } from '../types'

const { t } = getNs(['common'])
export const useCancelAcceleratedDepreciation = (
  ledgerSettingId: number,
  onCancelSuccess?: () => void,
  setError?: (error: Cancel_Accelerated_Depreciation_Error) => void
) => {
  const { biid } = useParams<{ biid: string }>()
  const [isCanceling, setCanceling] = useState(false)

  const cancelAcceleratedDepreciation = async (onHideCancelModal: () => void) => {
    setCanceling(true)
    const response = await tryCallApi(FixedAssetsService.putFixedAssetsByBiidDepreciationResultsCancelAdjust)(
      biid,
      { ledger_setting_id: ledgerSettingId },
      getAxiosSilent()
    )
    if (response.data) {
      messageSuccess(t('messages.cancel_success'))
      onCancelSuccess?.()
    }
    if (response.error) {
      const parsedError = parseCancelAcceleratedError(response.error)
      if (parsedError.isKnownError) {
        setError?.(parsedError)
      } else {
        handleErrorResponse(response.error, undefined, { showToast: true })
      }
    }
    setCanceling(false)
    onHideCancelModal()
  }

  return { isCanceling, cancelAcceleratedDepreciation }
}
